export const hasValue = value => (value && value !== '') ? true : false;

export const isNumber = value => value && isNaN(Number(value)) ? true : false;

export const isValidEmail = value =>
    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i.test(value) ?
        false : true;
